/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Divider, Toolbar, useMediaQuery } from '@mui/material';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from './Header';
import Sidebar from './Sidebar';
import Sidebar2 from './Sidebar - Copy';
import navigation from 'menu-items';
//import navigation from 'menu-items/itemlist'
import { drawerWidth } from 'store/constant';
import { SET_MENU } from 'store/actions';
import { IconChevronRight } from '@tabler/icons';
import AuthFooter from '../../ui-component/cards/AuthFooter';

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    ...theme.typography.mainContent,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    backgroundColor: 'transparent',
    ...(!open && {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        }),
        [theme.breakpoints.up('lg')]: {
            marginLeft: -drawerWidth, //(drawerWidth - 20)
            width: `calc(100% - ${drawerWidth}px)`,
            paddingLeft: '40px',
            paddingRight: '40px',
            padding: '20px',
            paddingBottom: '0px'
        },
        [theme.breakpoints.between('md', 'lg')]: {
            marginLeft: -drawerWidth, //(drawerWidth - 20)
            width: `calc(100% - ${drawerWidth}px)`,
            paddingLeft: '40px',
            paddingRight: '40px',
            padding: '20px',
            paddingBottom: '0px'
        },
        [theme.breakpoints.down('md')]: {
            // marginLeft: '20px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '20px'
        },
        [theme.breakpoints.down('sm')]: {
            marginLeft: '10px',
            width: `calc(100% - ${drawerWidth}px)`,
            padding: '10px', //new
            marginRight: '10px'
        }
    }),
    [theme.breakpoints.up('lg')]: {
        marginLeft: open ? 0 : -drawerWidth, //(drawerWidth - 20)
        width: `calc(100% - ${drawerWidth}px)`,
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingBottom: '0px',
        backgroundColor: '#EEF2F6'
    },
    [theme.breakpoints.between('md', 'lg')]: {
        marginLeft: open ? -240 : -drawerWidth, //(drawerWidth - 20)
        width: `calc(100% - ${drawerWidth}px)`,
        paddingLeft: '40px',
        paddingRight: '40px',
        paddingBottom: '0px',
        backgroundColor: '#EEF2F6'
    },
    [theme.breakpoints.down('md')]: {
        // marginLeft: open ? 0 : '20px',
        width: `calc(100% - ${drawerWidth}px)`,
        padding: '10px', //new
        backgroundColor: '#EEF2F6'
    },
    [theme.breakpoints.down('sm')]: {
        // marginLeft: open ? 0 : '10px',
        width: `calc(100% - ${drawerWidth}px)`,
        padding: '20px' //new
        // marginRight: '10px'
    }
}));

const MainLayout = () => {
    const theme = useTheme();
    const [isLoading, setLoading] = useState(true); //loading status

    const leftDrawerOpened = useSelector((state) => state.customization.opened);
    const dispatch = useDispatch();

    const handleLeftDrawerToggle = () => {
        dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    };

    useEffect(() => {
        setLoading(true);
    }, []);

    return (
        <Box sx={{ display: 'flex', backgroundColor: '#EEF2F6' }}>
            <CssBaseline />
            <AppBar
                enableColorOnDark
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: '#EEF2F6', // theme.palette.background.default,
                    transition: theme.transitions.create(['margin', 'width'], {
                        easing: theme.transitions.easing.sharp,
                        duration: 2000
                    })
                }}
            >
                <Toolbar
                    sx={{
                        backgroundColor: '#EEF2F6',
                        ...(useMediaQuery(theme.breakpoints.up('lg'))
                            ? { marginLeft: leftDrawerOpened ? '260px' : '90px', paddingLeft: '10px' }
                            : {})
                    }}
                >
                    <Header handleLeftDrawerToggle={handleLeftDrawerToggle} value={leftDrawerOpened} />
                </Toolbar>
                <Divider
                    className="gradient-divider"
                    sx={{
                        marginLeft: {
                            xs: 0, // Mobile: 0 margin
                            sm: 0,
                            md: leftDrawerOpened ? '260px' : '100px' // Tablet and above: conditional
                        }
                    }}
                />
            </AppBar>
            <Sidebar drawerOpen={leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} isLoading={isLoading} />
            {useMediaQuery(theme.breakpoints.up('lg')) && !leftDrawerOpened && (
                <Sidebar2 drawerOpen={!leftDrawerOpened} drawerToggle={handleLeftDrawerToggle} isLoading={isLoading} />
            )}
            <Main theme={theme} open={leftDrawerOpened}>
                <Breadcrumbs separator={IconChevronRight} navigation={navigation} icon title rightAlign />
                <Outlet />
                <AuthFooter />
            </Main>
        </Box>
    );
};

export default MainLayout;
